<template>
	<div>
		<div class="msg_box ">
			<div class="jorn_left">
				<div class="tech_title">新闻动态</div>
				<div class="jorn_title" v-for="(itme,i) in journalismList" :key="i"
				:class="{'jorn_chon':className==itme.url}" @click="xin.goUrl(itme.url);pageNo=1">{{itme.value}}</div>
			</div>
			<div class="jorn_right">
				<div  class="zui_dynamic">
					<!-- 产品最新动态 -->
					<div class="min_he400" v-loading="loading" v-if="pageIndex==0">
						<div v-for="item in newList.data" :key="item.id" class="dynamic clearfloat">
							<div @click="gojourm(item.id)" class="dyn_imgs">
								<img v-if="item.images" :src="item.images"/>
								<!-- <div class="dyn_time">
									<span class="dyn_ti_title">{{item.create_time | timeFormat('d')}}</span>
									<span>{{item.create_time | timeFormat('yyyy-mm')}}</span>
								</div> -->
								<div v-else class="dyn_time_wen">{{item.create_time|timeFormat('年月日')}}</div>
							</div>
							<div class="dyn_characters">
								<span class="dyn_title" @click="gojourm(item.id)">{{item.title}}</span>
								<span class="dyn_content">{{item.subtitle}}</span>
								<div class="dyn_title2">产品分类：
									<span class="laing" @click="xin.goUrl('/oneDetails?cid='+item.category_id)">{{item.category}}</span>
								</div>
								<div class="dyn_title2">
									产品货号：
									<div>
										<span v-for="val in item.product" :key="val.id" @click="xin.goUrl('/products/'+val.id)" class="laing">{{val.model}}</span> 
									</div>
								</div>
								<div class="dyn_btn laing_btn" @click="gojourm(item.id)">查看更多</div>
							</div>
						</div>
					</div>
					<!-- 文献最新动态 -->
					<div class="min_he400" v-loading="loading" v-else-if="pageIndex==1">
						<div v-for="item in wenxianList.data" :key="item.id" class="literature clearfloat">
							<div class="lit_left">
								<div class="lit_btn laing_btn" @click="xin.goUrl('/oneDetails?cid='+item.category_id)">{{item.category}}</div>
							</div>
							<div class="lit_right">
								<div class="lit_title laing " @click="gojourm(item.id)">{{item.title}}</div>
								<div>{{item.subtitle}}</div>
								<div>
									<span class="lit_author">作者：</span>
									<span >{{item.publisher}}</span>
								</div>
								<div>
									<span class="lit_author">期刊：</span>
									{{item.source}}
								</div>
								<div>
									<span class="lit_author">产品货号：</span>
									<div>
										<span class="laing" v-for="val in item.product" @click="xin.goUrl('/products/'+val.id)" :key="val.id" >{{val.model}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 公司新闻 -->
					<div class="min_he400" v-loading="loading" v-else-if="pageIndex==2">
						<div v-for="item in gonsiList.data" :key="item.id" class="dynamic clearfloat">
							<div class="dyn_imgs">
								<div class="dyn_time_wen">{{item.create_time | timeFormat('年月日')}}</div>
							</div>
							<div class="dyn_characters">
								<span class="dyn_title" @click="gojourm(item.id)">{{item.title}}</span>
								<span class="dyn_content mar_bott_40">{{item.subtitle}}</span>
								<div class="dyn_btn laing_btn " @click="gojourm(item.id)">查看更多</div>
							</div>
						</div>
					</div>
				</div>
				<div class="bottom_paging">
					<el-pagination :total="total" hide-on-single-page @current-change="handleCurrentChange"
						:page-size="limit" :current-page="pageNo"  background layout="prev, pager, next"  > </el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex'
	export default {
		data(){
			return {
				loading:true,
				pageNo:1,//当前页
				total:0,//总数量
				limit:6,
				wenxianList:[],//最新文献新闻
				gonsiList:[],//公司新闻
				newList:[],//最新产品新闻
				pageIndex:0,//新闻索引
				journalismList:[
					{
						value:"产品最新动态",
						url:"/journalism/news"
					},
					{
						value:"文献最新动态",
						url:"/journalism/product"
					},
					{
						value:"公司新闻",
						url:"/journalism/company"
					}
				]
			}
		},
		watch:{
			$route(to,frm){
				this.setclassName(to.path);
				this.ifdata(to.path);
			}
		},
		computed:{
			...mapState(['className'])
		},
		created() {
			this.ifdata(this.$route.path);
		},
		methods:{
			...mapMutations(['setclassName','setactiveIndex']),
			async Postnewlist(){//新闻数据请求
				this.loading = true;
				let pageIndex = this.pageIndex+1;
				let {data} = await this.api.Postnewlist({type:pageIndex,page:this.pageNo,limit:this.limit});
				this.total = data.total;
				this.limit = data.per_page;
				switch(pageIndex){
					case 1:
						this.newList = data;
					break;
					case 2:
						this.wenxianList = data;
					break;
					case 3:
						this.gonsiList = data;
					break;
				}
				this.loading = false;
			},
			handleCurrentChange(val){//分页点击
				this.pageNo = val;
				this.Postnewlist(val)
			},
			ifdata(path){//路由判断
				if(path == '/journalism/news')
					this.pageIndex=0;
				else if(path == '/journalism/product')
					this.pageIndex=1;
				else if(path == '/journalism/company')
					this.pageIndex=2;

				this.Postnewlist();
			},
			gojourm(id){
				this.xin.goUrl('/jourDetails?nid='+id);
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.msg_box{
		display: flex;
		justify-content: space-between;
	}
	.jorn_left{
		.jorn_title{
			cursor: pointer;
			line-height: 60px;
			font-size: 20px;
			color: #666666;
		}
		.jorn_chon{
			color: var(--themeColor);
		}
	}
	.jorn_right{
		margin-top: 50px;
		width: 1000px;
		.zui_dynamic .dynamic .dyn_characters{
			width: 700px;
		}
	}
	.literature {
			width: 1023px;
			margin-top: 50px;

			.lit_left {
				float: left;

			}

			.lit_right {
				float: right;
				width: 743px;
				color: #666666;
				font-size: 20px;

				.lit_title {
					text-decoration: none;
					// cursor: default;
				}

				.lit_author {
					font-weight: 600;
					color: #000;
				}

				&>div {
					line-height: 36px;
				}
			}
		}
</style>
